import {
  Box,
  HStack,
  LinkBox,
  LinkOverlay,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import React from 'react';

import { isExternalLink } from '../../../utils/link.utils';
import ImageHandler from '../../ImageHandler';
import Link from '../../Link';
import { H3, Text } from '../../Text';

interface BioCardProps {
  name: string;
  title?: string | null | undefined;
  image: StaticImageDef | React.ReactElement;
  bioUrl: string;
  location: string | null | undefined;
}

const BioCard: React.FC<BioCardProps> = ({
  image,
  name,
  title,
  location,
  bioUrl,
  children,
}) => {
  const styles = useMultiStyleConfig('BioCard', {});

  return (
    <Box as={LinkBox} __css={styles.card}>
      <HStack spacing="2rem">
        <Box __css={styles.image}>
          <ImageHandler image={image} />
        </Box>
        <Box __css={styles.info}>
          <H3 sx={styles.name}>{name}</H3>
          <Text sx={styles.title}>{children}</Text>
          <Text sx={styles.location}>{location}</Text>
          <LinkOverlay
            as={Link}
            __css={styles.link}
            to={bioUrl}
            alignItems="left"
            isExternal={isExternalLink(bioUrl)}
          >
            Read Bio
          </LinkOverlay>
        </Box>
      </HStack>
    </Box>
  );
};

export default BioCard;
